import { Button, Card, CardContent, CardHeader, CardMedia, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel } from "@mui/material";
import { useState } from "react";
import { Commons } from "../../helper/CommonService";
import { API_HOST, APP_HOST, BE_HOST, KETERSEDIAAN } from "../../helper/Constant";
import LoadingButton from "@mui/lab/LoadingButton";
import ShowNotif from "../general/ShowNotif";
import { LibraryAddCheck, SaveOutlined } from "@mui/icons-material";
import DialogCommonTitle from "./DialogCommonTitle";

function DialogBerkas({ isOpen, handleClose, rowDetail, handleChangeData }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingLengkap, setIsLoadingLengkap] = useState(false);
    const [isNotifShow, setIsNotifShow] = useState(false);
    const [notifData, setNotifData] = useState({});
    if (!rowDetail) {
        return (
            <></>
        )
    }

    const SubmitData = () => {
        setIsLoading(true);
        const { name, no_daftar, ...result } = rowDetail;
        Commons.UpdateData(API_HOST + "/berkas/" + rowDetail.id, result, true)
            .then((responseData) => {
                setNotifData({
                    "status": "success",
                    "message": "Update data successfully"
                });
            })
            .catch((responseErr) => {
                setNotifData({
                    "status": "error",
                    "message": "Fail update data"
                });
                console.log(responseErr);
            })
            .finally(() => {
                setIsLoading(false);
                setIsNotifShow(true);
            });
    }

    const VerifikasiLengkap = () => {
        setIsLoadingLengkap(true);
        let updateData = {
            isUpload_berkas: 1,
            isBerkas_verified: 1
        };
        Commons.UpdateData(API_HOST + "/progress/" + rowDetail.id, updateData, true)
            .then((responseData) => {

            })
            .catch((responseErr) => {
                console.log(responseErr);
            })
            .finally(() => {
                setIsLoadingLengkap(false);
            });
    }

    const ShowImage = (imageSrc) => {
        if (!imageSrc) {
            return APP_HOST + "/notfound.jpg"
        }
        return BE_HOST + "/storage/" + imageSrc;
    }

    return (
        <>
            <ShowNotif isShow={isNotifShow} actionClose={() => { setIsNotifShow(false); }} data={notifData}></ShowNotif>
            <Dialog fullWidth maxWidth={"md"} open={isOpen} onClose={handleClose}>
                <DialogTitle>
                    <DialogCommonTitle dialogTitle={"Detail Berkas"} detailName={rowDetail.nama} noWa={rowDetail.waNo}></DialogCommonTitle>
                </DialogTitle>
                <DialogContent>
                    <Card sx={{ mb: "10px" }}>
                        <CardHeader title="Check Foto"></CardHeader>
                        <CardMedia sx={{ width: "400px" }} component={"img"} image={ShowImage(rowDetail.foto_santri)}>
                        </CardMedia>
                        <CardContent>
                            <FormControlLabel control={<Checkbox checked={(rowDetail.isFoto === KETERSEDIAAN.SUDAH)} name="isFoto" onChange={(e) => { handleChangeData(e, rowDetail.id); }} />} label="Foto Sudah Sesuai?" />
                        </CardContent>
                    </Card>
                    <Card sx={{ mb: "10px" }}>
                        <CardHeader title="Check Surat Kesanggupan"></CardHeader>
                        <CardMedia sx={{ width: "400px" }} component={"img"} image={ShowImage(rowDetail.surat_kesanggupan)}>
                        </CardMedia>
                        <CardContent>
                            <FormControlLabel control={<Checkbox checked={(rowDetail.isSuratKesanggupan === KETERSEDIAAN.SUDAH)} name="isSuratKesanggupan" onChange={(e) => { handleChangeData(e, rowDetail.id); }} />} label="Surat kesanggupan Sudah Sesuai?" />
                        </CardContent>
                    </Card>
                    <Card sx={{ mb: "10px" }}>
                        <CardHeader title="Check Akta Kelahiran"></CardHeader>
                        <CardMedia sx={{ width: "400px" }} component={"img"} image={ShowImage(rowDetail.akta_kelahiran)}>
                        </CardMedia>
                        <CardContent>
                            <FormControlLabel control={<Checkbox checked={(rowDetail.isAktaKelahiran === KETERSEDIAAN.SUDAH)} name="isAktaKelahiran" onChange={(e) => { handleChangeData(e, rowDetail.id); }} />} label="Akta Kelahiran Sudah Sesuai?" />
                        </CardContent>
                    </Card>
                    <Card sx={{ mb: "10px" }}>
                        <CardHeader title="Check Kartu Keluarga"></CardHeader>
                        <CardMedia sx={{ width: "400px" }} component={"img"} image={ShowImage(rowDetail.kartu_keluarga)}>
                        </CardMedia>
                        <CardContent>
                            <FormControlLabel control={<Checkbox checked={(rowDetail.isKartuKeluarga === KETERSEDIAAN.SUDAH)} name="isKartuKeluarga" onChange={(e) => { handleChangeData(e, rowDetail.id); }} />} label="Kartu Keluarga Sudah Sesuai?" />
                        </CardContent>
                    </Card>
                    <Card sx={{ mb: "10px" }}>
                        <CardHeader title="Check Bukti Hafalan"></CardHeader>
                        <CardMedia sx={{ width: "400px" }} component={"img"} image={ShowImage(rowDetail.bukti_hafalan)}>
                        </CardMedia>
                        <CardContent>
                            <FormControlLabel control={<Checkbox checked={(rowDetail.isBuktiHafalan === KETERSEDIAAN.SUDAH)} name="isBuktiHafalan" onChange={(e) => { handleChangeData(e, rowDetail.id); }} />} label="Bukti Hafalan Sudah Sesuai?" />
                        </CardContent>
                    </Card>
                    <br></br>
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        variant="contained"
                        onClick={SubmitData}
                        startIcon={<SaveOutlined></SaveOutlined>}
                    >
                        {isLoading ? "Processing" : "Verifikasi Data"}
                    </LoadingButton>
                    &nbsp;&nbsp;
                    <LoadingButton startIcon={<LibraryAddCheck></LibraryAddCheck>} loadingPosition="start" variant="contained" color="success" onClick={VerifikasiLengkap}>
                        {isLoadingLengkap ? "Processing" : "Verifikasi Lengkap"}
                    </LoadingButton>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default DialogBerkas;